/**
 *  New fragment for extended custom product fields
 */

export default `
  #graphql
  fragment CustomExtendedProductFields on ProductInterface {
    ean
    delivery_time
    czynniki_stresowe
    kondycja_rosliny
    substancja_czynna
    purpose
    status_rejestracji
    korzysci_stosowania
    Regeneracja_upraw
    aktywacja_upraw
    Budowanie_plonu_i_jakosci
    zwiekszanie_odpornosci_upraw
    sklad
    termin_waznosci_produktu
    forma_pakowania
    forma_transportu
    pakowanie_hurtowe_produktu
  }
`;
